/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelArControl.ts                     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/ar-control";

export class AutogenModelArControl<RowType extends ModelRow> extends Endpoint<RowType, RowArControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowArControl extends ModelRow<RowArControlFields> {
	constructor(values?: Partial<RowArControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowArControlFields {
	accrue_nonbroker_expense: string;
	adjust_passwd: string;
	age_pd_1_call: number;
	age_pd_1_call_c: string;
	age_pd_1_call_d: Date;
	age_pd_1_call_n: number;
	age_pd_1_call_r: number;
	age_pd_2_call: number;
	age_pd_2_call_c: string;
	age_pd_2_call_d: Date;
	age_pd_2_call_n: number;
	age_pd_2_call_r: number;
	age_pd_3_call: number;
	age_pd_3_call_c: string;
	age_pd_3_call_d: Date;
	age_pd_3_call_n: number;
	age_pd_3_call_r: number;
	age_pd_4_call: number;
	age_pd_4_call_c: string;
	age_pd_4_call_d: Date;
	age_pd_4_call_n: number;
	age_pd_4_call_r: number;
	age_period_1: number;
	age_period_1_desc: string;
	age_period_2: number;
	age_period_2_desc: string;
	age_period_3: number;
	age_period_3_desc: string;
	age_period_4: number;
	age_period_4_desc: string;
	agent_exp_accrual_glid: string;
	agent_pay_accrual_glid: string;
	allow_alt_rev_share: string;
	alternate_rev_share_descr: string;
	ar_glid: string;
	ar_rtflag: string;
	auto_collect_days: number;
	base_aging: string;
	bill_due_days: number;
	bill_orderby: string;
	bill_ready2bill: string;
	bill_template: number;
	bill_transfer_when: string;
	c_bill_template: number;
	c_cust_stmt_tmplat: number;
	c_misc_bill_tmplat: number;
	c_summary_template: number;
	carrier_exp_accrual_glid: string;
	carrier_pay_accrual_glid: string;
	cash_glid: string;
	chassis_chargeby: string;
	chassis_freedays: number;
	chassis_occode: string;
	chassis_rate: number;
	chassis_rate_c: string;
	chassis_rate_d: Date;
	chassis_rate_n: number;
	chassis_rate_r: number;
	combine_eforms: string;
	company_accrual_percentage: number;
	company_exp_accrual_glid: string;
	company_id: string;
	company_pay_accrual_glid: string;
	container_autooc: string;
	container_chargeby: string;
	container_freedays: number;
	container_occode: string;
	container_rate: number;
	container_rate_c: string;
	container_rate_d: Date;
	container_rate_n: number;
	container_rate_r: number;
	currency_bank_fee_glid: string;
	currency_realized_glid: string;
	currency_rounding_glid: string;
	currency_unrealized_glid: string;
	cust_change_email: string;
	cust_stmt_template: number;
	dedicated_template: number;
	default_rev_share_descr: string;
	enforce_bill_print: string;
	enforce_reason: string;
	fin_chg_cutoff_1: number;
	fin_chg_cutoff_1_c: string;
	fin_chg_cutoff_1_d: Date;
	fin_chg_cutoff_1_n: number;
	fin_chg_cutoff_1_r: number;
	fin_chrg_glid: string;
	fin_chrg_min_days: number;
	fin_chrg_minimum: number;
	fin_chrg_minimum_c: string;
	fin_chrg_minimum_d: Date;
	fin_chrg_minimum_n: number;
	fin_chrg_minimum_r: number;
	fin_chrg_percent_1: number;
	fin_chrg_percent_2: number;
	fin_chrg_unc_glid: string;
	fuel_price_file: string;
	fuel_price_file_monthly: string;
	fuel_price_host: string;
	fuel_price_region: string;
	ic_revenue_glid: string;
	id: number;
	include_split_point: string;
	invoice_due_template: number;
	invoice_method: string;
	is_dedicated_active: string;
	is_intercompany: string;
	is_logix_licensed: boolean;
	is_paperwork_licensed: boolean;
	is_password_licensed: boolean;
	master_prgrss_bill: string;
	max_credit_adj: number;
	max_credit_adj_c: string;
	max_credit_adj_d: Date;
	max_credit_adj_n: number;
	max_credit_adj_r: number;
	max_debit_adjust: number;
	max_debit_adjust_c: string;
	max_debit_adjust_d: Date;
	max_debit_adjust_n: number;
	max_debit_adjust_r: number;
	min_revenue_date: Date;
	misc_bill_template: number;
	misc_rev_glid: string;
	mpw_carrier_contact_method: string;
	mpw_days_to_wait: number;
	mpw_detail_carrier: string;
	mpw_detail_driver: string;
	mpw_driver_contact_method: string;
	mpw_method: string;
	mpw_missing_paperwork_high: number;
	mpw_missing_paperwork_low: number;
	mpw_orders: string;
	mpw_sender_email: string;
	mpw_summary_carrier: string;
	mpw_summary_carrier_recip: string;
	mpw_summary_dispatch: string;
	mpw_summary_dispatch_recip: string;
	mpw_summary_driver: string;
	mpw_summary_driver_recip: string;
	notify_groups: string;
	notify_users: string;
	owner_accrual_percentage: number;
	owner_exp_accrual_glid: string;
	owner_pay_accrual_glid: string;
	pd0_alert: number;
	pd1_c: string;
	pd1_np: string;
	pd1_np_auto: string;
	pd1_sp: string;
	pd1_sp_auto: string;
	pd1_sp_thresh: number;
	pd1_sp_thresh_c: string;
	pd1_sp_thresh_d: Date;
	pd1_sp_thresh_n: number;
	pd1_sp_thresh_r: number;
	pd2_c: string;
	pd2_np: string;
	pd2_np_auto: string;
	pd2_sp: string;
	pd2_sp_auto: string;
	pd2_sp_thresh: number;
	pd2_sp_thresh_c: string;
	pd2_sp_thresh_d: Date;
	pd2_sp_thresh_n: number;
	pd2_sp_thresh_r: number;
	pd3_c: string;
	pd3_np: string;
	pd3_np_auto: string;
	pd3_sp: string;
	pd3_sp_auto: string;
	pd3_sp_thresh: number;
	pd3_sp_thresh_c: string;
	pd3_sp_thresh_d: Date;
	pd3_sp_thresh_n: number;
	pd3_sp_thresh_r: number;
	pd4_c: string;
	pd4_np: string;
	pd4_np_auto: string;
	pd4_sp: string;
	pd4_sp_auto: string;
	pd4_sp_thresh: number;
	pd4_sp_thresh_c: string;
	pd4_sp_thresh_d: Date;
	pd4_sp_thresh_n: number;
	pd4_sp_thresh_r: number;
	post_revenue_by: string;
	receivable_accrual_glid: string;
	rend_delta: number;
	rendition_billing: string;
	revenue_accrual_glid: string;
	revenue_adj_glid: string;
	revenue_glid: string;
	round_up_fuel: string;
	summary_template: number;
	suppress_mileage_override: string;
	tonu_other_charge_code: string;
	transfer_to_settlement: string;
	use_bank_curr_for_conv_fee: string;
	use_bill_due_for_past_due: string;
	use_max_adjust: string;
	use_min_revenue_dt: string;
	use_recent_exchange_rate: string;
}

